import api from './api';

export interface VIP {
  id: number;
  full_name: string;
  cpf?: string;
  residential_address?: string;
  email?: string;
  phone?: string;
  role_title?: string;
  company_name?: string;
  notes?: string;
  is_active: boolean;
  created_at: string;
}

export interface VIPCreate {
  full_name: string;
  cpf?: string;
  residential_address?: string;
  email?: string;
  phone?: string;
  role_title?: string;
  company_name?: string;
  notes?: string;
  is_active?: boolean;
}

export interface VIPUpdate {
  full_name?: string;
  cpf?: string;
  residential_address?: string;
  email?: string;
  phone?: string;
  role_title?: string;
  company_name?: string;
  notes?: string;
  is_active?: boolean;
}

export const vipsService = {
  async getAll(): Promise<VIP[]> {
    const response = await api.get('/api/v2/vips/');
    return response.data;
  },

  async getActive(): Promise<VIP[]> {
    const response = await api.get('/api/v2/vips/active');
    return response.data;
  },

  async getById(id: number): Promise<VIP> {
    const response = await api.get(`/api/v2/vips/${id}`);
    return response.data;
  },

  async create(vip: VIPCreate): Promise<VIP> {
    const response = await api.post('/api/v2/vips/', vip);
    return response.data;
  },

  async update(id: number, vip: VIPUpdate): Promise<VIP> {
    const response = await api.put(`/api/v2/vips/${id}`, vip);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/api/v2/vips/${id}`);
  }
};
